import {
	createActionsHook,
	createContainer,
	createDefaultEocWrapper,
	createHook,
	createStore,
} from '@atlassian/eoc-rss-helpers';

import { type ProgressState, ProgressContents } from './types';

const initialState: ProgressState = {
	activeContent: ProgressContents.Home,
	activeTask: null,
	latestContent: ProgressContents.Home,
	isOpen: false,
};

const Store = createStore({
	initialState,
	actions: {
		open:
			() =>
			({ setState }) => {
				setState({
					isOpen: true,
					activeContent: ProgressContents.Home,
				});
			},
		close:
			() =>
			({ setState }) => {
				setState({ isOpen: false });
			},
		changeActiveContent:
			(content: ProgressContents, task?: number) =>
			({ setState }) => {
				setState({ activeContent: content, activeTask: task || null });
			},
		backToHome:
			(latestContent: ProgressContents) =>
			({ setState }) => {
				setState({ activeContent: ProgressContents.Home, latestContent });
			},
	},
	name: 'progress',
});

const useProgressStore = createHook(Store);
const useProgressActions = createActionsHook(Store);
const ProgresContainer = createContainer(Store, {
	Wrapper: createDefaultEocWrapper({}),
});

export { useProgressStore, useProgressActions, ProgresContainer };
